import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

// ----------------------------------------------------------------------

export function useScrollToTop() {
  const pathname = useLocation({
    select: (location) => location.pathname,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
